export default "__VITE_ASSET__CLS1ZNdj__"